import { ReactNode } from 'react';

import { useAmpContext } from 'utils/AmpContext';

import { ButtonBarHolder, InnerButtonBarHolder } from './ButtonBar.styled';

type Props = {
  children: ReactNode;
};

export function ButtonBar({ children }: Props) {
  const isAmp = useAmpContext();
  if (isAmp) return null;

  return (
    <ButtonBarHolder id="button-bar-container">
      <InnerButtonBarHolder>{children}</InnerButtonBarHolder>
    </ButtonBarHolder>
  );
}
